export const STRINGS = {
  it: {
    nav: { "/": "Home", "/chi-siamo": "Chi siamo", "/cosa-facciamo": "Cosa facciamo", "/progetti": "Progetti", "/contatti": "Contatti" },
    menu: "Menu",
    tagline: "Associazione di promozione sociale",
    runts: "Iscritta al RUNTS",
    hero: {
      eyebrow: "Associazione di promozione sociale",
      lines: ["Oltre", "i confini,", "assieme."],
      text: "Progetti culturali, educativi e sociali con particolare attenzione ai programmi europei Erasmus+. Per il dialogo interculturale, la sostenibilità e la partecipazione attiva dei giovani.",
      cta1: "Scopri chi siamo",
      cta2: "Segui i progetti",
      badge: "Erasmus+ • Europa • Comunità •",
      scroll: "Scorri",
    },
    marquee: ["Erasmus+", "Esperienze internazionali", "Outdoor", "Inclusione sociale", "Formazione", "Sostenibilità", "Comunità"],
    intro: {
      eyebrow: "Chi siamo",
      a: "Promuoviamo attività formative, esperienze internazionali, iniziative outdoor e percorsi di ",
      em: "inclusione sociale",
      b: ", insieme ai giovani e alle comunità locali.",
      link: "La nostra storia",
    },
    bento: { eyebrow: "Cosa facciamo", t1: "Quattro aree,", t2: "una sola direzione.", all: "Tutte le attività" },
    areas: [
      { id: "erasmus", title: "Erasmus+ e programmi europei", text: "Progettiamo e realizziamo scambi, mobilità e partenariati internazionali nell'ambito dei programmi europei Erasmus+." },
      { id: "formazione", title: "Attività formative", text: "Percorsi educativi e formativi per giovani, educatori e operatori, basati sull'apprendimento non formale." },
      { id: "outdoor", title: "Iniziative outdoor", text: "Esperienze all'aria aperta come strumento di crescita, relazione e consapevolezza ambientale." },
      { id: "inclusione", title: "Inclusione sociale", text: "Percorsi che favoriscono la partecipazione attiva di tutte e tutti, a partire dalle comunità locali." },
    ],
    reveal: { a: "Oltre i confini,", b: "assieme." },
    spotlight: { eyebrow: "Progetti", title: "Segui i nostri progetti, passo dopo passo.", text: "Racconti, aggiornamenti e opportunità dai progetti in corso: tutto sul nostro blog.", cta: "Vai al blog" },
    homeCta: { title: "Hai un'idea, una domanda o vuoi partecipare?", label: "Contattaci" },
    chi: {
      eyebrow: "Chi siamo",
      lines: ["Un'associazione", "in ascolto."],
      intro: "Lunghe Frequenze è un'associazione di promozione sociale attiva nella realizzazione di progetti culturali, educativi e sociali, con particolare attenzione ai programmi europei Erasmus+.",
      missionEyebrow: "La nostra missione",
      mission: "Favorire il dialogo interculturale, la sostenibilità e la partecipazione attiva dei giovani e delle comunità locali.",
      missionText: "Lo facciamo promuovendo attività formative, esperienze internazionali, iniziative outdoor e percorsi di inclusione sociale: occasioni concrete per incontrarsi, imparare e crescere insieme.",
      valuesEyebrow: "I nostri valori",
      valuesTitle: "Ciò che ci tiene sulla stessa frequenza.",
      values: [
        { k: "Dialogo interculturale", v: "Incontrare culture diverse per costruire comprensione reciproca." },
        { k: "Sostenibilità", v: "Agire con cura verso le persone, i territori e l'ambiente." },
        { k: "Partecipazione attiva", v: "Mettere giovani e comunità al centro, come protagonisti." },
        { k: "Inclusione", v: "Creare spazi accessibili, dove ognuno trova il proprio posto." },
      ],
      cta: { title: "Scopri le nostre aree di intervento.", label: "Cosa facciamo" },
    },
    cosa: {
      eyebrow: "Cosa facciamo",
      lines: ["Quattro aree", "di intervento."],
      intro: "Formazione, Europa, natura e inclusione: quattro modi diversi per generare incontro, crescita e partecipazione.",
      cta: { title: "Vuoi vedere i progetti in azione?", label: "Vai ai progetti" },
    },
    progetti: {
      eyebrow: "Progetti",
      lines: ["Storie che", "viaggiano lontano."],
      intro: "Ogni progetto è un incontro tra persone, territori e culture.",
      listEyebrow: "I nostri progetti, dal primo all'ultimo",
      statProjects: "Progetti",
      statCountries: "Paesi",
      statYears: "Anni di attività",
      cta: { title: "Vuoi partecipare a un progetto?", label: "Scrivici" },
    },
    contatti: {
      eyebrow: "Contatti",
      lines: ["Sintonizziamoci."],
      intro: "Per informazioni sui progetti, collaborazioni o per partecipare alle nostre attività, scrivici: ti risponderemo il prima possibile.",
      email: "Email",
      write: "Scrivi una email",
      copy: "Copia indirizzo",
      copied: "Copiata",
      toastOk: "Email copiata",
      toastErr: "Copia non riuscita",
      social: "Social",
      blog: "Sede",
      country: "Italia",
      assoc: "Associazione",
    },
    footer: { write: "Scrivici", desc: "Associazione di promozione sociale per progetti culturali, educativi e sociali.", blog: "Blog dei progetti" },
  },
  en: {
    nav: { "/": "Home", "/chi-siamo": "About us", "/cosa-facciamo": "What we do", "/progetti": "Projects", "/contatti": "Contact" },
    menu: "Menu",
    tagline: "Social promotion association",
    runts: "Registered in RUNTS",
    hero: {
      eyebrow: "Social promotion association",
      lines: ["Beyond", "borders,", "together."],
      text: "Cultural, educational and social projects with a special focus on the European Erasmus+ programmes. For intercultural dialogue, sustainability and the active participation of young people.",
      cta1: "Discover who we are",
      cta2: "Follow our projects",
      badge: "Erasmus+ • Europe • Community •",
      scroll: "Scroll",
    },
    marquee: ["Erasmus+", "International experiences", "Outdoor", "Social inclusion", "Training", "Sustainability", "Community"],
    intro: {
      eyebrow: "About us",
      a: "We promote training activities, international experiences, outdoor initiatives and pathways of ",
      em: "social inclusion",
      b: ", together with young people and local communities.",
      link: "Our story",
    },
    bento: { eyebrow: "What we do", t1: "Four areas,", t2: "one direction.", all: "All activities" },
    areas: [
      { id: "erasmus", title: "Erasmus+ and European programmes", text: "We design and deliver exchanges, mobility and international partnerships within the European Erasmus+ programmes." },
      { id: "formazione", title: "Training activities", text: "Educational and training pathways for young people, educators and youth workers, based on non-formal learning." },
      { id: "outdoor", title: "Outdoor initiatives", text: "Outdoor experiences as a tool for growth, connection and environmental awareness." },
      { id: "inclusione", title: "Social inclusion", text: "Pathways that foster everyone's active participation, starting from local communities." },
    ],
    reveal: { a: "Beyond borders,", b: "together." },
    spotlight: { eyebrow: "Projects", title: "Follow our projects, step by step.", text: "Stories, updates and opportunities from our ongoing projects: all on our blog.", cta: "Go to the blog" },
    homeCta: { title: "Have an idea, a question or want to take part?", label: "Get in touch" },
    chi: {
      eyebrow: "About us",
      lines: ["An association", "that listens."],
      intro: "Lunghe Frequenze is a social promotion association delivering cultural, educational and social projects, with a special focus on the European Erasmus+ programmes.",
      missionEyebrow: "Our mission",
      mission: "Fostering intercultural dialogue, sustainability and the active participation of young people and local communities.",
      missionText: "We do it through training activities, international experiences, outdoor initiatives and social inclusion pathways: concrete opportunities to meet, learn and grow together.",
      valuesEyebrow: "Our values",
      valuesTitle: "What keeps us on the same frequency.",
      values: [
        { k: "Intercultural dialogue", v: "Meeting different cultures to build mutual understanding." },
        { k: "Sustainability", v: "Acting with care for people, places and the environment." },
        { k: "Active participation", v: "Putting young people and communities at the centre, as protagonists." },
        { k: "Inclusion", v: "Creating accessible spaces where everyone finds their place." },
      ],
      cta: { title: "Discover our areas of work.", label: "What we do" },
    },
    cosa: {
      eyebrow: "What we do",
      lines: ["Four areas", "of work."],
      intro: "Training, Europe, nature and inclusion: four different ways to create encounters, growth and participation.",
      cta: { title: "Want to see our projects in action?", label: "See projects" },
    },
    progetti: {
      eyebrow: "Projects",
      lines: ["Stories that", "travel far."],
      intro: "Every project is a meeting of people, places and cultures.",
      listEyebrow: "Our projects, from first to latest",
      statProjects: "Projects",
      statCountries: "Countries",
      statYears: "Years of activity",
      cta: { title: "Want to join a project?", label: "Write to us" },
    },
    contatti: {
      eyebrow: "Contact",
      lines: ["Let's tune in."],
      intro: "For information about our projects, partnerships or to take part in our activities, write to us: we will get back to you as soon as possible.",
      email: "Email",
      write: "Send an email",
      copy: "Copy address",
      copied: "Copied",
      toastOk: "Email copied",
      toastErr: "Copy failed",
      social: "Social",
      blog: "Address",
      country: "Italy",
      assoc: "Association",
    },
    footer: { write: "Write to us", desc: "Social promotion association for cultural, educational and social projects.", blog: "Projects blog" },
  },
};
